// ملف sharebtn.js البسيط
import React, { useContext } from "react";
import { Download } from "lucide-react";
import { LanguageContext } from "./LanguageContext";

const ShareButton = ({
  handleExportToExcel,
  loading,
  styles,
  handleSecondaryBtnMouseEnter,
  handleSecondaryBtnMouseLeave,
}) => {
  const { language } = useContext(LanguageContext);

  const text = {
    en: { exportexcel: "Export Excel" },
    ar: { exportexcel: "تحميل إكسل" }
  };

  return (
    <button
      style={{
        ...styles.secondaryBtn,
        opacity: loading ? 0.7 : 1,
        cursor: loading ? "not-allowed" : "pointer",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        direction: language === "ar" ? "rtl" : "ltr",
      }}
      disabled={loading}
      onClick={handleExportToExcel}
      onMouseEnter={(e) => handleSecondaryBtnMouseEnter(e, "#f59e0b")}
      onMouseLeave={handleSecondaryBtnMouseLeave}
    >
      <Download size={16} />
      {text[language].exportexcel}
    </button>
  );
};

export default ShareButton;